var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["category-secondary-navigation.j2"] = require( "category-secondary-navigation.j2" );
dependencies["facets/category-facets-filter-icon.j2"] = require( "facets/category-facets-filter-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-navigation-outer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")) {
output += "\n    <div class=\"o-row\">\n\n        <div class=\"g-category-navigation-small__categories\" data-qa-placeholder-dropdown>\n\n            ";
output += "\n            ";
env.getTemplate("category-secondary-navigation.j2", false, "category/templates/category-navigation-outer.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n        </div>\n\n\t    <div class=\"g-category-navigation-small__facets\">\n\n\t        <a class=\"c-facets-link-small__open-filters js-mobile-filter\" href=\"#\" data-qa-mobile-filter-button>\n\n                ";
output += "\n\n                ";
env.getTemplate("facets/category-facets-filter-icon.j2", false, "category/templates/category-navigation-outer.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n                <span class=\"c-facets-link-small__label\">";
output += runtime.suppressValue((lineno = 27, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["catalog_facets-filter"])), env.opts.autoescape);
output += "</span>\n\n\t        </a>\n\n\t    </div>\n\n    </div>";
})})})});
}
else {
output += "\n    <div class=\"o-row\">\n\n        ";
env.getTemplate("category-secondary-navigation.j2", false, "category/templates/category-navigation-outer.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n    </div>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-navigation-outer.j2"] , dependencies)